var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatingMonsterLikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6673 3.55566C18.6673 3.55566 21.334 5.33344 19.5562 9.77789L19.5556 9.77788C19.5556 10.9549 18.9836 11.9983 18.1024 12.6454C20.1369 13.5421 26.566 13.8057 25.7366 8.00011C25.6104 7.12011 26.6255 7.11122 27.5144 8.00011C30.1811 10.6668 32.8478 14.9637 31.07 25.7779C28.4033 21.3334 25.7366 22.2223 24.8478 26.6668C22.3934 23.3943 19.9391 24.6397 18.1777 26.2448C17.4516 27.1043 16.6644 27.5558 16.001 27.5558C15.3736 27.5558 14.6354 27.1519 13.9428 26.3809C12.1726 24.7133 9.6493 23.3023 7.12597 26.6668C6.23709 22.2223 3.57042 21.3334 0.903752 25.7779C-0.874026 14.9637 1.79264 10.6668 4.45931 8.00011C5.3482 7.11122 6.36331 7.12011 6.23709 8.00011C5.40547 13.8214 11.8718 13.5406 13.8878 12.6381C13.0122 11.9905 12.4446 10.9505 12.4445 9.77788L12.4435 9.77789C10.6658 5.33344 13.3324 3.55566 13.3324 3.55566C13.3324 3.55566 14.7653 4.27211 15.0583 6.34822C15.3582 6.26603 15.674 6.22215 16.0001 6.22215C16.326 6.22215 16.6416 6.266 16.9415 6.34812C17.2345 4.27209 18.6673 3.55566 18.6673 3.55566Z",
    fill: "url(#paint0_linear_10496_10896)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10496_10896",
    x1: 22.041,
    y1: 11.7006,
    x2: 22.041,
    y2: 25.1708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F00FF",
    stopOpacity: 0.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatingMonsterLikeIcon);
export default __webpack_public_path__ + "static/media/dating-monster-like-icon.f23b6e23ecc3c3842c229b4ee3ccee4c.svg";
export { ForwardRef as ReactComponent };